import {Component, State, Prop, h, Element } from '@stencil/core';
import { v4 as uuidv4 } from 'uuid';
import {overrideSettings} from "../../utils/utils";
import Swal from 'sweetalert2';

@Component({
  tag: 'fdi-tooltip',
  styleUrl: 'fdi-tooltip.scss',
  shadow: true,
})

export class FDITooltip {

  @Prop() __settings: any;
  @Prop() __html: string;

  @Element() private shadowRoot: ShadowRoot;

  @State() id;
  @State() displayTooltip: boolean = false;
  @State() settings: any = {
    tooltipText: '',
    openInModal: false,
    showOnClick: false,
    meta: {},
    style: {
      general: {
        fontSize: '15px',
        color: 'black',
        padding: '5px',
        bottom: 'calc( 100% + 5px )'
      },
    }
  };

  componentWillLoad(){
    let settings = this.__settings;

    if ( settings && typeof settings === 'string' ){
      settings = JSON.parse( settings );
    }

    if ( !settings ){
      settings = this.settings;
    }

    const html = this.__html;
    if ( html && html.trim() ){
      settings.tooltipText = html.trim();
    }

    this.settings = overrideSettings( this.settings, settings );
    this.id = uuidv4();
  }

  componentDidLoad(){
    let parent = this.shadowRoot.parentElement;
    if ( this.settings.showOnClick ){
      parent.addEventListener( 'click', ( e ) => {
        e.preventDefault();
        if ( this.displayTooltip ){
          this.hideTooltip();
        }
        else{
          this.showTooltip();
        }
      });
    }
    else{
      parent.addEventListener( 'mouseover', () => {
        this.showTooltip();
      });
      parent.addEventListener( 'mouseout', () => {
        this.hideTooltip();
      });
    }
  }

  showTooltip(){
    this.displayTooltip = true;
  }

  hideTooltip(){
    this.displayTooltip = false;
  }

  render() {
    if ( this.settings.openInModal && this.displayTooltip ){
      Swal.fire({
        html: this.settings.tooltipText,
        showConfirmButton: false,
        showClass: {
          popup: ''
        },
        padding: '0 5px 5px 5px',
        customClass: {
          container: 'modal'
        },
        didClose: () => {
          this.displayTooltip = false;
        },
        willOpen: () => {
          const styleId = 'fdi-wc-tooltip-swal-css-rules';
          const existing = document.getElementById( styleId );
          if ( !existing ){
            const opts = [
              '.swal2-popup { border-radius: 0 !important; }',
            ];
            const style = document.createElement( 'style' );
            style.innerHTML = opts.join( '' );
            style.id = styleId;
            document.body.appendChild( style );
          }
        }
      })
      return;
    }
    let containerSettings = {
      display: this.displayTooltip ? 'block' : 'none'
    };
    return (
      <div
        id={ this.id }
        class={ 'fdi wc tooltip' }
        style={ containerSettings }
      >
        <span style={ this.settings.style.general } innerHTML={ this.settings.tooltipText }> </span>
      </div>
    );
  }
}
